<template>
    <transition>
        <div class="Complements">
            <div class="Complements__container" :class="'is-'+ step">
                <div class="Complements__block left">
                    <div class="Complements__language" @click="$root.langSwitch()">{{ this.getLang() }}</div>
                    <div ref="cristaux" class="Complements__button" @click="onClick('cristaux')">    
                        <div class="Complements__button-title" v-html="trans('PAGES.MOMENTA.title')"/>
                        <div class="Complements__button-desc" v-html="trans('PAGES.MOMENTA.texte')"/>
                    </div>
                    <div ref="biennale" class="Complements__button" @click="onClick('biennale')">
                        <div class="Complements__button-title" v-html="trans('PAGES.BIENNALE.title')"/>
                        <div class="Complements__button-desc" v-html="trans('PAGES.BIENNALE.texte')"/>
                    </div>
                    <div ref="credits" class="Complements__button bottom" @click="onClick('credits')">
                        <div class="Complements__button-title" v-html="trans('PAGES.CREDITS.title')"/>
                    </div>
                </div>
                <div id="complements" class="Complements__block right"> 

                    <Credits v-if="title == 'credits'"/>
                    <Momenta v-if="title == 'cristaux'"/>
                    <Biennale v-if="title == 'biennale'"/>

                   <!--  
                   <div ref="back" class="Complements__back" @click="callBack()">
                        <img :src="require('@/commons/img/back.png')">
                    </div> 
                    -->

                </div>
            </div>     
        </div>
    </transition>
</template>

<script>

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import MotionPathPlugin from "gsap/MotionPathPlugin"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, ScrollToPlugin)

import Credits from './Credits.vue'
import Momenta from './Momenta.vue'
import Biennale from './Biennale.vue'

export default {
    name: 'Complements',
    components: { Credits, Momenta, Biennale },
    data: ()=>({
        step: 'left',
        title: ''
    }),
    beforeCreate() {
        window.scrollTo(0,0)
    },

    watch: {
        'step'(nw){
            if(nw == 'left') 
                gsap.delayedCall(.5, ()=> { this.title = null })
        }
    },
    mounted() {
        this.$nextTick(()=>{
            gsap.from(this.$el, { duration: .5, alpha: 0 })
            gsap.from(".Complements__button", { duration: .5, y: 200, ease: "cubic.out", alpha: 0, delay: .5, stagger: .15 })
        })
    },
    methods: { 

        getLang() {
            return this.lang == 'fr' ? 'EN' : 'FR'
        },

        onClick(arg) {
            this.step = 'right'
            this.title = arg
            // gsap.from(this.$refs.back, { duration: .35, x: 30, delay: .2, alpha: 0 })
        },
        callBack() {
            gsap.to(this.$refs.back, { 
                duration: .5, 
                x: 30, 
                ease: "cubic.in",
                onComplete: ()=>{ gsap.set(this.$refs.back, { x: 0 }) } 
            })
            gsap.delayedCall(.15, ()=>{ this.step = 'left' })
        },
        leave() {
            return new Promise(res => {
                if(this.step == 'left') 
                    gsap.timeline()
                        .to(".Complements__button", { 
                            duration: .5, 
                            y: 200, 
                            ease: "cubic.out", 
                            alpha: 0, 
                            stagger: -.05,
                        })
                        .to(this.$el, { duration: .35, alpha: 0, onComplete: ()=> res() })
                else 
                    gsap.to(this.$el, { duration: .5, alpha: 0, onComplete: ()=> res() })
            })
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Complements 

    display flex
    background-color white
    position absolute
    top 0
    left 0
    width 100vw
    height 100%
    overflow hidden
    z-index 50

    &__container
        display flex
        align-items flex-start
        justify-content center
        flex-direction rows
        position absolute
        height 100%
        top 0
        transition transform .35s
        
        &.is-right
            transform translate(-50%, 0)

        &.is-left
            transform translate(0, 0)

    &__block
        position relative
        width 100vw
        height 100%

        &.left
            display flex
            align-items center
            justify-content center
            flex-direction column
            background url('~@/commons/img/background.png') no-repeat center center fixed
            background-size cover

        &.right
            display flex
            align-items center
            justify-content flex-start
            flex-direction column
            padding 30px
            overflow scroll     

    &__button 
        cursor pointer
        display flex
        flex-direction column
        align-items center
        font-weight 800
        text-transform uppercase
        padding 30px 15px

        &.bottom
            padding-bottom 20vh

        &-title
            font-size 22px
            text-align center
            line-height 24px

        &-desc
            font-size 15px

    &__back
        cursor pointer
        position absolute
        top 18px
        left 30px
        background transparent

        &.white
            background white

        & img 
            width 32px
            height 15px
            padding 22px 12px 14px

    &__title 
        font-weight 800
        font-size 24px
        text-align center
        line-height 20px

    &__desc
        padding 30px 30px 280px

    &__language 
        position absolute
        top 30px 
        right 30px
        font-size 16px
        font-weight 800

</style>














